import { TaskStatus, TaskType } from "enums/task.enum";
import { humanize } from "utils/common";

export interface ITaskStatusDisplay {
    label: string;
    backgroundColor: string;
    color: string;
}

export interface ITaskTypeDisplay {
    label: string;
    code: string;
}

export const DEFAULT_TASK_STATUS_KEY = "DEFAULT";
export const DEFAULT_TASK_TYPE_KEY = "DEFAULT";

export const taskStatusDisplayMap: Record<string, ITaskStatusDisplay> = {
    [TaskStatus.SUCCESS]: {
        label: "Success",
        backgroundColor: "#DBFCE7",
        color: "#4B6B3B",
    },
    [TaskStatus.PENDING]: {
        label: "Pending",
        backgroundColor: "#FFF9C4",
        color: "#B76E00",
    },
    [TaskStatus.QUEUED]: {
        label: "Queued",
        backgroundColor: "#E0E7FF",
        color: "#4338CA",
    },
    [TaskStatus.IN_PROGRESS]: {
        label: "In Progress",
        backgroundColor: "#DBEAFE",
        color: "#1D4ED8",
    },
    [TaskStatus.SUSPENDED]: {
        label: "Suspended",
        backgroundColor: "#F3E8FF",
        color: "#7E22CE",
    },
    [TaskStatus.FAILED]: {
        label: "Failed",
        backgroundColor: "#FFE2E2",
        color: "#BE4E55",
    },
    [DEFAULT_TASK_STATUS_KEY]: {
        label: "Unknown",
        backgroundColor: "#F1F1F1",
        color: "#6B7280",
    },
};

export const taskTypeDisplayMap: Record<string, ITaskTypeDisplay> = {
    [TaskType.EXTRACT_EVENTS]: { label: "Extract Events", code: TaskType.EXTRACT_EVENTS },
    [TaskType.EXTRACT_INCIDENTS]: { label: "Extract Incidents", code: TaskType.EXTRACT_INCIDENTS },
    [TaskType.EXTRACT_REFERENCE_DATA]: { label: "Extract Reference Data", code: TaskType.EXTRACT_REFERENCE_DATA },
    [TaskType.GENERATE_REPORTS]: { label: "Generate Reports", code: TaskType.GENERATE_REPORTS },
    [TaskType.GENERATE_FILE]: { label: "Generate File", code: TaskType.GENERATE_FILE },
    [DEFAULT_TASK_TYPE_KEY]: { label: "Unknown", code: DEFAULT_TASK_TYPE_KEY },
};

export const getTaskStatusDisplay = (status: string): ITaskStatusDisplay => {
    const match = taskStatusDisplayMap[status];
    if (match) {
        return match;
    }
    return { ...taskStatusDisplayMap[DEFAULT_TASK_STATUS_KEY], label: humanize(status) };
};

export const getTaskTypeDisplay = (type: string): ITaskTypeDisplay => {
    const match = taskTypeDisplayMap[type];
    if (match) {
        return match;
    }
    return { ...taskTypeDisplayMap[DEFAULT_TASK_TYPE_KEY], label: humanize(type), code: type };
};
